import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BazisSelectComponent } from '@bazis/form/components/base/selects/select.component';

@Component({
    selector: 'app-select-with-tags',
    templateUrl: './select-with-tags.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SelectWithTagsComponent extends BazisSelectComponent {
    @Input() placeholderKeyValue: string = '';

    @Input() displayCount: number = 6;

    multiple = true;

    toggleValues(e) {
        e.stopPropagation();
        let countForTrash = this.values._.length - this.displayCount;

        for (let i = 0; i < countForTrash; i++) {
            this.toggleValue(this.values._[this.values._.length - 1]);
        }
    }

    onClear() {
        this.values._.forEach((val) => {
            this.toggleValue(val);
        });
        this.ngControl.control.setValue(this.emptyValue || (this.multiple ? [] : null));
    }

    selectAll(selectedList, optionsList) {
        optionsList.forEach((item) => {
            if (!selectedList.includes(item)) {
                this.toggleValue(item.id);
            }
        });
    }

    unSelectAll(list) {
        list.forEach((item) => {
            this.toggleValue(item.id);
        });
    }

    toggleAll(selectedList, optionsList) {
        if (selectedList.length === this.options.length) {
            this.unSelectAll(selectedList);
        } else {
            this.selectAll(selectedList, optionsList);
        }
    }
}
